var map = {
	"./10clubs.jpg": "5dae",
	"./10diamonds.jpg": "968f",
	"./10hearts.jpg": "eccd",
	"./10spades.jpg": "c915",
	"./10stars.jpg": "5aff",
	"./3clubs.jpg": "3255",
	"./3diamonds.jpg": "fe8d",
	"./3hearts.jpg": "1f16",
	"./3spades.jpg": "d00e",
	"./3stars.jpg": "9564",
	"./4clubs.jpg": "ad81",
	"./4diamonds.jpg": "7713",
	"./4hearts.jpg": "57c9",
	"./4spades.jpg": "a1aa",
	"./4stars.jpg": "afe1",
	"./5clubs.jpg": "6dbb",
	"./5diamonds.jpg": "3c70",
	"./5hearts.jpg": "1748",
	"./5spades.jpg": "fa80",
	"./5stars.jpg": "4ae4",
	"./6clubs.jpg": "410c",
	"./6diamonds.jpg": "d2ad",
	"./6hearts.jpg": "d510",
	"./6spades.jpg": "5a9d",
	"./6stars.jpg": "eaee",
	"./7clubs.jpg": "c5b0",
	"./7diamonds.jpg": "1819",
	"./7hearts.jpg": "3b82",
	"./7spades.jpg": "194b",
	"./7stars.jpg": "51a9",
	"./8clubs.jpg": "1496",
	"./8diamonds.jpg": "7703",
	"./8hearts.jpg": "9404",
	"./8spades.jpg": "2f84",
	"./8stars.jpg": "5887",
	"./9clubs.jpg": "2f46",
	"./9diamonds.jpg": "4414",
	"./9hearts.jpg": "99e0",
	"./9spades.jpg": "9ab4",
	"./9stars.jpg": "d0af",
	"./A.jpg": "060b",
	"./B.jpg": "f28f",
	"./C.jpg": "f23c",
	"./CL.jpg": "2cf0",
	"./D.jpg": "69c1",
	"./E.jpg": "d875",
	"./ER.jpg": "b5bb",
	"./F.jpg": "136d",
	"./G.jpg": "b1e5",
	"./H.jpg": "fa62",
	"./I.jpg": "c533",
	"./IN.jpg": "d1fb",
	"./J.jpg": "9903",
	"./Jclubs.jpg": "2503",
	"./Jdiamonds.jpg": "0cf2",
	"./Jhearts.jpg": "0a72",
	"./Joker.jpg": "a442",
	"./Jspades.jpg": "c710",
	"./Jstars.jpg": "3b55",
	"./K.jpg": "30f5",
	"./Kclubs.jpg": "a418",
	"./Kdiamonds.jpg": "3d08",
	"./Khearts.jpg": "4e24",
	"./Kspades.jpg": "e066",
	"./Kstars.jpg": "aaa9",
	"./L.jpg": "e0c5",
	"./M.jpg": "83f0",
	"./N.jpg": "2e38",
	"./O.jpg": "ed79",
	"./P.jpg": "2ec2",
	"./Q.jpg": "3443",
	"./QU.jpg": "8672",
	"./Qclubs.jpg": "227a",
	"./Qdiamonds.jpg": "5228",
	"./Qhearts.jpg": "b896",
	"./Qspades.jpg": "c9e8",
	"./Qstars.jpg": "6303",
	"./R.jpg": "dd0c",
	"./S.jpg": "3b7a",
	"./T.jpg": "813b",
	"./TH.jpg": "7afe",
	"./U.jpg": "5784",
	"./V.jpg": "83ce",
	"./W.jpg": "f59d",
	"./X.jpg": "f49e",
	"./Y.jpg": "72fd",
	"./Z.jpg": "7f04",
	"./five-crowns.jpg": "1782",
	"./quiddler.jpg": "7b48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6863";